import { Bling } from "./bling";

let selectedBenefitIndex = 2;

function hideBenefits() {
  const left = Bling.$(`.coop-t-benefitbar__mobile:nth-child(1)`);
  const center = Bling.$(`.coop-t-benefitbar__mobile:nth-child(2)`);
  const right = Bling.$(`.coop-t-benefitbar__mobile:nth-child(3)`);

  left.style.cssText = "display: none !important";
  center.style.cssText = "display: none !important";
  right.style.cssText = "display: none !important";
}

function showBenefit() {
  const benefit = Bling.$(
    `.coop-t-benefitbar__mobile:nth-child(${selectedBenefitIndex})`
  );

  benefit.style.cssText = "display: block !important";
}

function decrementBenefitIndex() {
  if (selectedBenefitIndex > 1) {
    // Move backwards
    selectedBenefitIndex--;
  } else {
    // Loop around
    selectedBenefitIndex = 3;
  }
}

function incrementBenefitIndex() {
  if (selectedBenefitIndex < 3) {
    // Move forwards
    selectedBenefitIndex++;
  } else {
    // Loop around
    selectedBenefitIndex = 1;
  }
}

export function moveLeft() {
  hideBenefits();
  decrementBenefitIndex();
  showBenefit();
}

export function moveRight() {
  hideBenefits();
  incrementBenefitIndex();
  showBenefit();
}
